import { render } from "./assureur.vue?vue&type=template&id=1658426b&scoped=true"
import script from "./assureur.vue?vue&type=script&lang=js"
export * from "./assureur.vue?vue&type=script&lang=js"

import "./assureur.vue?vue&type=style&index=0&id=1658426b&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1658426b"]])

export default __exports__